export default __webpack_public_path__ + "static/media/projects.ce5970a5.geojson";